import { CommonRouter, Image } from '@common';
import { routerPaths } from './tool';
import Home from './index';
import { withRouter } from 'react-router-dom';
import Layout from './layout';
import { PrivacyStatement, TermsOfUse, FAQ } from '../../Common/components/footer';

const WithRouterLayout = withRouter(Layout);

function Router() {
    const routers = [
        {
            path: routerPaths.home,
            component: Home,
            exact: true,
        },
        {
            path: routerPaths.privacyStatement,
            component: PrivacyStatement,
            exact: true,
        }, {
            path: routerPaths.termsOfUse,
            component: TermsOfUse,
            exact: true,
        },
        {
            path: routerPaths.FAQ,
            component: FAQ,
            exact: true,
        },
    ];

    return (
        <WithRouterLayout
            logo={{
                icon: Image.admin.logo,
                to: "/student"
            }}
        >
            <CommonRouter routers={routers} />
        </WithRouterLayout>
    );
}

export default Router;